<template>
  <v-container>
    <v-row>
      <v-col class="col-12">
        <h4 class="q-mt-sm q-mb-sm">Update survey information</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <h5 class="q-mt-sm q-mb-sm">Details:</h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-6">
        <p>
          Customer: {{ survey.customer }}<br />
          Address: {{ survey.address }}
          Customer address:<br />
          <span v-if="survey.customerAddressOne">{{ survey.customerAddressOne }}<br /></span>
          <span v-if="survey.customerAddressTwo">{{ survey.customerAddressTwo }}<br /></span>
          <span v-if="survey.customerAddressThree">{{ survey.customerAddressThree }}<br /></span>
          <span v-if="survey.customerAddressFour">{{ survey.customerAddressFour }}<br /></span>
          <span v-if="survey.customerAddressFive">{{ survey.customerAddressFive }}<br /></span>
          <span v-if="survey.customerPostcode">{{ survey.customerPostcode }}<br /></span>
          Area(s) to be surveyed:
          <span v-if="survey.external">External</span>
          <span v-if="survey.internal">Internal</span>
        </p>
      </v-col>
      <v-col class="col-6">
        Date of survey: {{ survey.prettyDate }}<br />
        Contact: {{ survey.contact }}<br />
        Contact number: {{ survey.contact_number }}<br />
        Booking notes: {{ survey.booking_notes }}<br />
        Vehicle: {{ survey.vehicle }}<br />
        Requested by: {{ survey.requestor }}<br />
        To be surveyed by: {{ survey.surveyor }}
      </v-col>
    </v-row>
    <v-row v-if="surveySections.length > 0">
      <v-row>
        <v-col class="col-12">
          <h4 class="q-mt-sm q-mb-sm">Existing items:</h4>
        </v-col>
      </v-row>
      <v-row :key="index" v-for="(section, index) in surveySections">
        <v-col class="col-6">
          <p>Item #{{ (index + 1) }}</p>
          <p>
            <v-text-field
                filled
                label="Title"
                v-model="section.title" />
          </p>
          <p>
            <v-text-field
                filled
                label="Description"
                v-model="section.description" />
          </p>
          <p>
            <v-btn @click="saveDetails(index)" color="green">Save Details</v-btn>
          </p>
        </v-col>
        <v-col class="col-6">
          <v-row>
            <v-col
                class="col-3"
                :key="findex"
                v-for="(file, findex) in section.files">
              <img class="thumbnail" :src="file.uri" alt="" />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12" v-if="section.boqs">
          <h6 class="q-mt-xs q-mb-xs">BOQs</h6>
          <v-simple-table>
            <thead>
            <tr>
              <th class="text-left">Description</th>
              <th class="text-left">Material</th>
              <th class="text-left">Colour</th>
              <th class="text-left">Quantity</th>
              <th class="text-left">Unit</th>
              <th style="width:149px;">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(boq, bindex) in section.boqs" :key="bindex">
              <td>{{ boq.boq }}</td>
              <td>
                <v-select
                    dense
                    filled
                    hide-details="auto"
                    :items="materials"
                    item-text="text"
                    item-value="value"
                    v-model="boq.material_id" />
              </td>
              <td>
                <v-select
                  dense
                  filled
                  hide-details="auto"
                  :items="colours"
                  item-text="text"
                  item-value="value"
                  v-model="boq.colour_id" />
              </td>
              <td>
                <v-text-field
                  dense
                  filled
                  hide-details="auto"
                  type="number"
                  v-model.number="boq.quantity" />
              </td>
              <td>
                <v-text-field
                  dense
                  filled
                  hide-details="auto"
                  v-model="boq.unit" />
              </td>
              <td>
                <v-btn
                  @click="updateBoq(index, bindex)"
                  color="green"
                  x-small>Save</v-btn>
                &nbsp;
                <v-btn
                  @click="deleteBoq(index, bindex)"
                  color="red"
                  x-small>Delete</v-btn>
              </td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col class="col-12 q-pt-md" v-if="addedBoq.boq_id === 0">
          <v-row>
            <v-col class="col-6">
              <v-text-field
                  filled
                  hint=""
                  label="Start typing to lookup BOQ"
                  v-model="boqSearch" />
            </v-col>
          </v-row>
          <v-row v-if="foundBoqs.length > 0 && addedBoq.boq_id === 0">
            <v-col class="col-12">
              <v-simple-table>
                <thead>
                <tr>
                  <th class="text-left">Description</th>
                  <th class="text-left">Material</th>
                  <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(boq, index) in foundBoqs" :key="index">
                  <td>{{ boq.description}}</td>
                  <td>{{ boq.material }}</td>
                  <td>
                    <v-btn
                        @click="selectAddedBoq(index)"
                        color="green"
                        small>Select</v-btn>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12 q-pt-md">
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-text-field
                  disabled
                  filled
                  hint=""
                  label="BOQ Description"
                  v-model="addedBoq.boq_description" />
            </v-col>
          </v-row>
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-text-field
                  disable
                  filled
                  hint=""
                  label="BOQ Material"
                  v-model="addedBoq.boq_material" />
            </v-col>
          </v-row>
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-select
                  filled
                  hint=""
                  label="BOQ Colour"
                  :items="colours"
                  item-text="text"
                  item-value="value"
                  v-model="addedBoq.boq_colour" />
            </v-col>
          </v-row>
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-text-field
                  filled
                  hint=""
                  label="BOQ Quantity"
                  step="0.01"
                  type="number"
                  v-model.number="addedBoq.boq_quantity" />
            </v-col>
          </v-row>
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-text-field
                  filled
                  hint=""
                  label="BOQ Unit i.e. M2"
                  v-model="addedBoq.boq_unit" />
            </v-col>
          </v-row>
          <v-row v-if="addedBoq.boq_id > 0">
            <v-col class="col-12">
              <v-btn @click="saveAddedBoq(index)" color="green">Add BOQ</v-btn>
              &nbsp;
              <v-btn @click="clearAddedBoq" color="grey">Clear BOQ</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12 q-mt-md">
          <v-btn
              @click="deleteSection(index)"
              class="mb-2"
              color="red"
              small>Delete item</v-btn>
          <hr />
        </v-col>
      </v-row>
    </v-row>
    <v-row id="scroll-anchor" class="row q-mt-md">
      <v-col class="col-12">
        <h4 class="q-mt-sm q-mb-sm">Add a new item to the survey</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-text-field
          filled
          hint=""
          label="Title of next item on survey"
          v-model="newSection.title" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-text-field
            filled
            hint=""
            label="Description of next item on survey"
            v-model="newSection.description" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-text-field
            filled
            hint=""
            label="Current surface state for next item on survey"
            v-model="newSection.current_surface_state" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id === 0">
      <v-col class="col-6">
        <v-text-field
            filled
            hint=""
            label="Start typing to lookup BOQ"
            v-model="boqSearch" />
      </v-col>
    </v-row>
    <v-row v-if="foundBoqs.length > 0 && newBoq.boq_id === 0">
      <v-col class="col-12">
        <v-simple-table class="q-mb-md">
          <thead>
          <tr>
            <th class="text-left">Description</th>
            <th class="text-left">Material</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(boq, index) in foundBoqs" :key="index">
            <td>{{ boq.description}}</td>
            <td>{{ boq.material }}</td>
            <td>
              <v-btn
                  @click="selectBoq(index)"
                  color="green"
                  small>Select</v-btn>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-text-field
            disable
            filled
            hint=""
            label="BOQ Description"
            v-model="newBoq.boq_description" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-text-field
            disable
            filled
            hint=""
            label="BOQ Material"
            v-model="newBoq.boq_material" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-select
            filled
            hint=""
            label="BOQ Colour"
            :items="colours"
            item-value="value"
            item-text="text"
            v-model="newBoq.boq_colour" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-text-field
            filled
            hint=""
            label="BOQ Quantity"
            step="0.01"
            type="number"
            v-model.number="newBoq.boq_quantity" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-text-field
            filled
            hint=""
            label="BOQ Unit i.e. M2"
            v-model="newBoq.boq_unit" />
      </v-col>
    </v-row>
    <v-row v-if="newBoq.boq_id > 0">
      <v-col class="col-12">
        <v-btn @click="addBoq" color="green">Add BOQ</v-btn>
        &nbsp;
        <v-btn @click="clearBoq" color="grey">Clear BOQ</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="newSection.boqs.length > 0">
      <v-col class="col-12">
        <v-simple-table>
          <thead>
          <tr>
            <th class="text-left">Description</th>
            <th class="text-left">Material</th>
            <th class="text-left">Colour</th>
            <th class="text-left">Quantity</th>
            <th class="text-left">Unit</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(boq, index) in newSection.boqs" :key="index">
            <td>{{ boq.boq_description }}</td>
            <td>{{ boq.boq_material }}</td>
            <td>{{ boq.boq_colour.text }}</td>
            <td>{{ boq.boq_quantity }}</td>
            <td>{{ boq.boq_unit }}</td>
            <td>
              <v-btn
                  @click="removeBoq(index)"
                  color="red"
                  x-small>Remove</v-btn>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-btn @click="interimSaveSection" class="q-mb-sm" color="green" small>Save Section</v-btn>
      </v-col>
    </v-row>
    <v-dialog
        v-model="showMessage"
        max-width="290"
    >
      <v-card>
        <v-card-text class="pt-4">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="orange darken-2"
              text
              @click="showMessage = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'UpdateSurvey',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      addedBoq: {
        boq_id: 0,
        boq_colour: null,
        boq_description: '',
        boq_material: '',
        boq_quantity: 0,
        boq_unit: '',
        boq: '',
        id: 0,
        material: '',
        colour: '',
        quantity: 0,
        unit: '',
      },
      boqSearch: '',
      colours: [],
      foundBoqs: [],
      materials: [],
      message: '',
      newBoq: {
        boq_id: 0,
        boq_colour: null,
        boq_description: '',
        boq_material: '',
        boq_quantity: 0,
        boq_unit: '',
        boq: '',
        id: 0,
        material: '',
        colour: '',
        quantity: 0,
        unit: '',
      },
      newSection: {
        boqs: [],
        current_surface_state: '',
        description: '',
        files: [],
        id: 0,
        title: '',
      },
      showMessage: false,
      survey: {
        address: '',
        booking_notes: '',
        contact: '',
        contact_number: '',
        customer: '',
        customerAddressOne: '',
        customerAddressTwo: '',
        customerAddressThree: '',
        customerAddressFour: '',
        customerAddressFive: '',
        customerPostcode: '',
        external: false,
        id: 0,
        internal: false,
        prettyDate: '',
        requestor: '',
        surveyor: '',
        vehicle: '',
      },
      surveySections: [],
    };
  },
  methods: {
    addBoq() {
      const tempBoq = {
        boq_id: this.newBoq.boq_id,
        boq_colour: this.newBoq.boq_colour,
        boq_description: this.newBoq.boq_description,
        boq_material: this.newBoq.boq_material,
        boq_quantity: this.newBoq.boq_quantity,
        boq_unit: this.newBoq.boq_unit,
        boq: '',
        id: 0,
        material: '',
        colour: '',
        quantity: 0,
        unit: '',
      };
      axios.post(`/boqsSiteSurveySections/create/${this.newSection.id}.json?token=${this.token}`, tempBoq)
          .then((response) => {
            tempBoq.id = response.data.newBoq.id;
            this.newSection.boqs.push(tempBoq);
          });
      setTimeout(() => {
        this.boqSearch = '';
        this.newBoq.boq_id = 0;
        this.newBoq.boq_colour = null;
        this.newBoq.boq_description = '';
        this.newBoq.boq_material = '';
        this.newBoq.boq_quantity = 0;
        this.newBoq.boq_unit = '';
        this.newBoq.boq = '';
        this.newBoq.id = 0;
        this.newBoq.material = '';
        this.newBoq.colour = '';
        this.newBoq.quantity = 0;
        this.newBoq.unit = '';
      }, 200);
    },
    clearAddedBoq() {
      this.foundBoqs = [];
      this.addedBoq.boq_id = 0;
      this.addedBoq.colour = '';
      this.addedBoq.boq_description = '';
      this.addedBoq.boq_material = '';
      this.addedBoq.boq_quantity = 0;
      this.addedBoq.boq_unit = '';
      this.addedBoq.boq = '';
      this.addedBoq.id = 0;
      this.addedBoq.material = '';
      this.addedBoq.quantity = 0;
      this.addedBoq.unit = '';
    },
    clearBoq() {
      this.foundBoqs = [];
      this.newBoq.boq_id = 0;
      this.newBoq.colour = '';
      this.newBoq.boq_description = '';
      this.newBoq.boq_material = '';
      this.newBoq.boq_quantity = 0;
      this.newBoq.boq_unit = '';
      this.newBoq.boq = '';
      this.newBoq.id = 0;
      this.newBoq.material = '';
      this.newBoq.quantity = 0;
      this.newBoq.unit = '';
    },
    deleteBoq(index, bindex) {
      const section = this.surveySections[index];
      const boq = section.boqs[bindex];
      axios.get(`/boqsSiteSurveySections/delete/${boq.id}.json?token=${this.token}`)
          .then(() => {
            this.surveySections[index].boqs.splice(bindex, 1);
          });
    },
    deleteSection(index) {
      const section = this.surveySections[index];
      axios.get(`/siteSurveySections/delete/${section.id}.json?token=${this.token}`)
          .then(() => {
            this.surveySections.splice(index, 1);
          });
    },
    getColours() {
      axios.get(`/colours/getAll.json?token=${this.token}`)
          .then((response) => {
            this.colours = response.data;
          });
    },
    getFirstSection() {
      axios.get(`/siteSurveySections/create/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.newSection.id = response.data.id;
          });
    },
    getMaterials() {
      axios.get(`/materials/getAll.json?token=${this.token}`)
          .then((response) => {
            this.materials = response.data;
          });
    },
    getSurvey() {
      axios.get(`/siteSurveys/getOne/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.survey = response.data.survey;
          });
    },
    getSurveySections() {
      axios.get(`/siteSurveySections/get/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.surveySections = response.data.sections;
          });
    },
    interimSaveSection() {
      axios.post(`/siteSurveySections/update.json?token=${this.token}`, this.newSection);
    },
    removeBoq(index) {
      this.newSection.boqs.splice(index, 1);
    },
    saveAddedBoq(index) {
      const section = this.surveySections[index];
      const tempBoq = {
        boq_id: this.addedBoq.boq_id,
        boq_colour: this.addedBoq.boq_colour,
        boq_description: this.addedBoq.boq_description,
        boq_material: this.addedBoq.boq_material,
        boq_quantity: this.addedBoq.boq_quantity,
        boq_unit: this.addedBoq.boq_unit,
        boq: this.addedBoq.boq_description,
        id: 0,
        material: this.addedBoq.boq_material,
        colour: this.addedBoq.boq_colour.text,
        quantity: this.addedBoq.boq_quantity,
        unit: this.addedBoq.boq_unit,
      };
      axios.post(`/boqsSiteSurveySections/create/${section.id}.json?token=${this.token}`, tempBoq)
          .then((response) => {
            tempBoq.id = response.data.newBoq.id;
            this.surveySections[index].boqs.push(tempBoq);
            window.scrollBy(0, -200);
          });
      setTimeout(() => {
        this.boqSearch = '';
        this.addedBoq.boq_id = 0;
        this.addedBoq.boq_colour = null;
        this.addedBoq.boq_description = '';
        this.addedBoq.boq_material = '';
        this.addedBoq.boq_quantity = 0;
        this.addedBoq.boq_unit = '';
        this.addedBoq.boq = '';
        this.addedBoq.id = 0;
        this.addedBoq.material = '';
        this.addedBoq.colour = '';
        this.addedBoq.quantity = 0;
        this.addedBoq.unit = '';
      }, 200);
    },
    saveDetails(index) {
      const section = this.surveySections[index];
      axios.post(`/siteSurveySections/update/${section.id}.json?token=${this.token}`, section)
        .then(() => {
          this.message = 'The details have been saved.';
          this.showMessage = true;
        });
    },
    selectAddedBoq(index) {
      const boq = this.foundBoqs[index];
      this.addedBoq.boq_id = boq.id;
      this.addedBoq.boq_description = boq.description;
      this.addedBoq.boq_material = boq.material;
      setTimeout(() => {
        this.foundBoqs = [];
      }, 200);
    },
    selectBoq(index) {
      const boq = this.foundBoqs[index];
      this.newBoq.boq_id = boq.id;
      this.newBoq.boq_description = boq.description;
      this.newBoq.boq_material = boq.material;
      setTimeout(() => {
        this.foundBoqs = [];
      }, 200);
    },
    updateBoq(index, bindex) {
      const section = this.surveySections[index];
      const boq = section.boqs[bindex];
      axios.post(`/boqsSiteSurveySections/update.json?token=${this.token}`, boq)
          .then(() => {
            this.message = 'The BOQ has been updated';
            this.showMessage = true;
          });
    },
  },
  watch: {
    boqSearch() {
      if (this.boqSearch.length > 3) {
        axios.post(`/boqs/searchForSurvey.json?token=${this.token}`, this.boqSearch)
            .then((response) => {
              this.foundBoqs = response.data.boqs;
            });
      }
    },
  },
  mounted() {
    this.getColours();
    this.getMaterials();
    this.getSurvey();
    this.getFirstSection();
    this.getSurveySections();
  },
};
</script>
